import React from 'react';
import { Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t border-gray-200 pt-12 pb-8" data-id="element-46">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-47">
        <div className="flex flex-col lg:flex-row lg:justify-between gap-8 mb-8" data-id="element-48">
          {/* Brand Column */}
          <div className="lg:w-56 flex-shrink-0" data-id="element-49">
            <img src="https://cdn.magicpatterns.com/uploads/1hCDA3zzdjWRL7TqBKyeWc/Best-Vitamins-For-All.webp" alt="Best Vitamins For All" className="h-10 w-auto mb-4" data-id="element-50" />
            <p className="text-sm text-gray-500 mb-4" data-id="element-51">
              Providing the finest, safest, and most effective nutritional
              products since 1958.
            </p>
            <div className="flex items-center text-gray-600 mb-2" data-id="element-52">
              <Phone className="h-4 w-4 mr-2 text-[#0e7be1]" data-id="element-53" />
              <span className="text-sm" data-id="element-54">800-260-2808</span>
            </div>
          </div>

          {/* Middle 3 Columns - Centered */}
          <div className="flex flex-col sm:flex-row gap-8 sm:gap-16 lg:gap-20 justify-center" data-id="element-55">
            {/* Information */}
            <div data-id="element-56">
              <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-4" data-id="element-57">
                Information
              </h3>
              <ul className="space-y-3" data-id="element-58">
                <li data-id="element-59">
                  <a href="/Science.html" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-60">
                    Science
                  </a>
                </li>
                <li data-id="element-61">
                  <a href="/Vitality.html" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-62">
                    Vitality
                  </a>
                </li>
                <li data-id="element-63">
                  <a href="/neolife" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-64">
                    Why Choose NeoLife
                  </a>
                </li>
                <li data-id="element-65">
                  <a href="/neolife-products" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-66">
                    GNLD NeoLife Products
                  </a>
                </li>
              </ul>
            </div>

            {/* Customer Services */}
            <div data-id="element-67">
              <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-4" data-id="element-68">
                Customer Services
              </h3>
              <ul className="space-y-3" data-id="element-69">
                <li data-id="element-70">
                  <a href="/Privacypolicy.html" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-71">
                    Privacy Policy
                  </a>
                </li>
                <li data-id="element-72">
                  <a href="/Returnpolicy.html" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-73">
                    Return Policy
                  </a>
                </li>
                <li data-id="element-74">
                  <a href="/shipping-policy" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-75">
                    Shipping Policy
                  </a>
                </li>
              </ul>
            </div>

            {/* Customer Info */}
            <div data-id="element-76">
              <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-4" data-id="element-77">
                Customer Info
              </h3>
              <ul className="space-y-3" data-id="element-78">
                <li data-id="element-79">
                  <a href="/joingnldmembers" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-80">
                    Join
                  </a>
                </li>
                <li data-id="element-81">
                  <a href="/login" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-82">
                    Login Page
                  </a>
                </li>
                <li data-id="element-83">
                  <a href="/contact-us" className="text-sm text-gray-600 hover:text-[#0e7be1]" data-id="element-84">
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Logo Column */}
          <div className="flex flex-col items-center lg:items-end justify-start lg:w-32 flex-shrink-0" data-id="element-85">
            <img src="https://cdn.magicpatterns.com/uploads/ssrgMdZGi9uTcmdb8AVR45/GNLD-secondary-logo.webp" alt="GNLD NeoLife" className="h-20 w-auto opacity-90" data-id="element-86" />
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-87">
          <p className="text-sm text-gray-500 text-center md:text-left" data-id="element-88">
            &copy; 2024 BestVitaminsForAll.com - GNLD NeoLife Independent
            Distributor
          </p>
          <p className="text-xs text-gray-400 mt-2 md:mt-0 text-center md:text-right max-w-md" data-id="element-89">
            These statements have not been evaluated by the Food and Drug
            Administration. These products are not intended to diagnose, treat,
            cure or prevent any disease.
          </p>
        </div>
      </div>
    </footer>;
}